export const slugify = (text: string): string => {
  if (!text) return '';

  return (
    text
      .toLowerCase()
      .trim()
      // 비ASCII 문자 제거 (한글, 한자, 특수문자 등)
      .replace(/[^a-z0-9\s-]/g, '')
      // 공백을 하이픈으로 변환
      .replace(/\s+/g, '-')
      // 연속된 하이픈을 하나로 통합
      .replace(/-+/g, '-')
      // 앞뒤 하이픈 제거
      .replace(/^-+|-+$/g, '')
  );
};
